import React from 'react';
import { Col } from 'react-bootstrap';
import { formatAmountWithLocale } from '../helper/common.helper';

interface TotalsDisplaySectionProps {
  isCalculateInvoiceLoading: boolean;
  calculatedSubAmount: any;
  currency: string;
  language: string;
  vat: number;
  vatAmount: number;
  isCalculationLoading: boolean;
  handleShowCalculationBreakdown: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  t: (key: string) => string;
}

export const TotalsDisplaySection: React.FC<TotalsDisplaySectionProps> = ({
  isCalculateInvoiceLoading,
  calculatedSubAmount,
  currency,
  language,
  vat,
  vatAmount,
  isCalculationLoading,
  handleShowCalculationBreakdown,
  t,
}) => {
  return (
    <Col xs={12} md={12} lg={12} xl={5} xxl={4} className="totals-section">
      <div className="totals-box">
        <div className="subtotal-row">
          <span className="total-label">{t('SUB_TOTAL')} :</span>
          <div className="total-values">
            <div className="total-amount">
              {isCalculateInvoiceLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                formatAmountWithLocale(
                  calculatedSubAmount?.response?.totalCalculation.amount || 0,
                  currency,
                  language
                )
              )}
            </div>
            <div className="vat-text">
              +{vat}% {t('VAT_LABEL')} ({vatAmount > 0 ? formatAmountWithLocale(vatAmount, currency, language) : '0'})
            </div>
          </div>
        </div>
        <div className="final-total-row">
          <span className="total-label">{t('TOTAL')} :</span>
          <span className="final-amount">
            {isCalculateInvoiceLoading ? (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
              formatAmountWithLocale(
                calculatedSubAmount?.response?.totalCalculation.amountIncludingVat || 0,
                currency,
                language
              )
            )}
          </span>
        </div>
        <div className="calculation-link">
          <a 
            href="#" 
            className={`link-text ${isCalculateInvoiceLoading ? 'disabled' : ''}`}
            onClick={isCalculateInvoiceLoading ? (e) => e.preventDefault() : handleShowCalculationBreakdown}
            style={{ 
              pointerEvents: isCalculateInvoiceLoading ? 'none' : 'auto',
              opacity: isCalculateInvoiceLoading ? 0.5 : 1,
              cursor: isCalculateInvoiceLoading ? 'not-allowed' : 'pointer'
            }}
          >
            {isCalculationLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {t('LOADING') || 'Loading...'}
              </>
            ) : (
              <>
                {t('SEE_HOW_WE_CALCULATED')}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="#717680" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </>
            )}
          </a>
        </div>
      </div>
    </Col>
  );
};
